import { isEmpty } from "lodash";
import CardDiv from "modules/common/card-div/CardDiv";
import SettingData from "modules/configure_settings/SettingData";
import SettingTable from "modules/configure_settings/SettingTable";
import { useSettingsStore } from "modules/configure_settings/store";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { isDownloadDisabled } from "modules/utilities/utility";
import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";

function Settings() {
  const { settingData, settingLoading, fetchSettingsData } = useSettingsStore();
  const [page, newPage] = useState(1);
  const [filterData, setFilter] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [sortedData, setSortedData] = useState([]);
  const [moreModalVisible, setMoreModalVisible] = useState(false);

  useEffect(() => {
    fetchSettingsData();
  }, []);

  useEffect(() => {
    if (isEmpty(settingData)) {
      setSortedData([]);
    } else {
      const settingMapData = settingData?.data.map((settings) => ({
        id: settings?.id,
        key: settings?.key,
        value: settings?.value,
        is_editable: settings?.is_editable,
        userid: settings?.userid,
      }));
      settingMapData.sort((settingOne, settingTwo) =>
        settingOne.key.localeCompare(settingTwo.key)
      );
      setSortedData(settingMapData);
    }
  }, [settingData]);

  useEffect(() => {
    async function calculate() {
      const numOfSubarrays = Math.max(
        Math.ceil((sortedData?.length || 0) / 10),
        0
      );

      const paginationArray = sortedData
        ? Array.from({ length: numOfSubarrays }, (_, index) => {
            const start = index * 10;
            const end = start + 10;
            return sortedData?.slice(start, end);
          })
        : [];
      setPageCount(Math.min(Math.ceil((sortedData?.length || 0) / 10), 100));
      setFilter(paginationArray[page - 1]);
    }
    calculate();
  }, [sortedData, page]);

  const handleMoreModalOpen = () => {
    setMoreModalVisible(true);
  };

  const handleMoreModalClose = () => {
    setMoreModalVisible(false);
  };

  return (
    <div>
      <CardDiv
        title={
          <div className="d-flex justify-content-between">
            <div className="fs-2 fw-bold">Settings</div>
            <div className="align-items-center">
              <Button variant="primary" onClick={handleMoreModalOpen} disabled={isDownloadDisabled}>
                Downloads
              </Button>
            </div>
          </div>
        }
        component={
          <>
            <SettingTable settingData={filterData} isLoading={settingLoading} />
            <PaginationDiv
              newPage={newPage}
              paginationData={{
                pageCount: pageCount || 1,
                page: page,
              }}
            />
          </>
        }
      />

      <Modal
        show={moreModalVisible}
        onHide={handleMoreModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Download and Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column gap-3  w-100">
            <SettingData
              title="Serviceable Pincodes"
              onCloseMoreModal={handleMoreModalClose}
            />
            <SettingData
              title="Non Serviceable Combinations"
              onCloseMoreModal={handleMoreModalClose}
            />
            <SettingData
              title="Blocked Customers"
              onCloseMoreModal={handleMoreModalClose}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleMoreModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Settings;